<script setup>
import { ref, computed, watch } from "vue";
import { useUserGroupStore } from "@/stores/useUserGroupStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const props = defineProps({
  association: { type: Object, required: true },
});

const emit = defineEmits(["close", "refresh", "notify"]);
const store = useUserGroupStore();

// Congelar nomes para a mensagem não mudar após clique/delete/refresh
const frozenUserName = ref("");
const frozenGroupName = ref("");

function freeze() {
  frozenUserName.value = props.association?.userName?.trim?.() || "";
  frozenGroupName.value = props.association?.groupName?.trim?.() || "";
}

watch(
  () => [props.association?.userName, props.association?.groupName],
  () => freeze(),
  { immediate: true }
);

const title = "Apagar Vínculo";

const messageTitle = computed(() => {
  const u = frozenUserName.value;
  const g = frozenGroupName.value;

  if (u && g) return `Você está prestes a apagar o vínculo entre "${u}" e "${g}".`;
  if (u) return `Você está prestes a apagar o vínculo deste usuário: "${u}".`;
  if (g) return `Você está prestes a apagar o vínculo deste grupo: "${g}".`;
  return "Você está prestes a apagar este vínculo.";
});

const messageSubtitle = "Esta ação não pode ser desfeita.";

function buildErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir o vínculo."
  );
}

async function onConfirm() {
  freeze();

  try {
    await store.deleteAssociationById(props.association.userGroupId);

    emit("notify", {
      type: "success",
      message: "Vínculo Pessoa-Grupo apagado com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildErrorMessage(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    :title="title"
    :messageTitle="messageTitle"
    :messageSubtitle="messageSubtitle"
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirm"
    @close="emit('close')"
  />
</template>
